// extracted by mini-css-extract-plugin
export default {"section":"LessonPage_section__-oV4c","section-list":"LessonPage_section-list__VZYjk","sheet":"LessonPage_sheet__mSESE","section-categories":"LessonPage_section-categories__7omhH"};